import {
  HomeIcon,
  PartnersIcon,
  ChatIcon,
  ProjectsIcon,
  TeamsIcon,
  TasksIcon,
  CalendarIcon,
  DocumentIcon,
} from "../../../assets/icons";
import { ContractGenerateIcon } from "../../../assets/icons/ContractGenerate";

export const allNavigationItems = [
  {
    path: "/dashboard",
    label: "Home",
    icon: HomeIcon,
  },
  {
    path: "/network",
    label: "Network",
    icon: PartnersIcon,
    hiddenForClient: true,
  },
  {
    path: "/chat",
    label: "Chat",
    icon: ChatIcon,
    hiddenForClient: true,
  },
  {
    path: "/teams",
    label: "Teams",
    icon: TeamsIcon,
    hiddenForClient: true,
  },
  {
    path: "/projects",
    label: "Projects",
    icon: ProjectsIcon,
    subItems: [
      { path: "/tasks", label: "Tasks", icon: TasksIcon, hiddenForClient: true },
      { path: "/calendar", label: "Calendar", icon: CalendarIcon, hiddenForClient: true },
      { path: "/files", label: "Files", icon: DocumentIcon, projectScoped: true },
    ],
  },
  {
    path: "/draft-flow",
    label: "Draft Flow",
    badge: "Beta",
    icon: ContractGenerateIcon,
    hiddenForClient: true,
  },
];
